import React, { memo } from 'react';
import { func, bool } from 'prop-types';
import { reduxForm } from 'redux-form';
import { validateAnimatedCreditCard, required } from '@widergy/web-utils/lib/validate';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { scrollToInvalid } from '@widergy/web-utils/lib/form';
import { UTButton, UTLoading } from '@widergy/energy-ui';

import { PAYMENT_FORM } from 'constants/reduxForms';
import { creditCardErrorMessages } from 'constants/validationMessages';
import { documentTypeField, documentNumberField, emailField } from 'constants/fields';
import { FIELD_ANIMATED_CREDIT_CARD, FIELD_SELECT } from 'constants/userForms';
import UTForm from 'app/components/UTForm';
import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';

import styles from './styles.module.scss';

const creditCardChildKeys = ['cardnumber', 'holdername', 'cvm', 'expmonth', 'expyear'];

const fields = [
  {
    id: '2',
    type: FIELD_SELECT,
    key: 'paymentMethod',
    title: message('Payments:paymentMethod'),
    field_options: appConfig.paymentFlow.paymentMethods,
    validate: [required(message('Validations:required'))]
  },
  {
    id: '1',
    type: FIELD_ANIMATED_CREDIT_CARD,
    key: 'cardNumber',
    validate: [validateAnimatedCreditCard(creditCardErrorMessages, creditCardChildKeys)],
    child_keys: creditCardChildKeys
  },
  emailField,
  documentTypeField,
  documentNumberField
];

const PaymentForm = ({ handleSubmit, onCancel, submitFailed, invalid, loading }) => (
  <div className={styles.container}>
    <UTLoading loading={loading} className={styles.loading}>
      <form onKeyDown={handleKeyDown(handleSubmit)} onSubmit={handleSubmit} className={styles.form}>
        <UTForm fields={fields} />
        <div className={styles.actions}>
          <UTButton secondary onPress={onCancel} className={styles.button}>
            {message('Commons:cancel')}
          </UTButton>
          <UTButton type="submit" disabled={submitFailed && invalid} className={styles.button}>
            {message('Payments:send')}
          </UTButton>
        </div>
      </form>
    </UTLoading>
  </div>
);

PaymentForm.propTypes = {
  handleSubmit: func,
  onCancel: func,
  submitFailed: bool,
  invalid: bool,
  loading: bool
};

export default reduxForm({ form: PAYMENT_FORM, onSubmitFail: errors => scrollToInvalid(errors) })(
  memo(PaymentForm)
);
